<template>
  <hic-dialog :close-on-click-modal="false" class="tx-c" :visible="visible" append-to-body title="费用结算" @close="cancel" @open="open" width="80%" top="10vh" :destroy-on-close="true">
    <el-main style="padding: 10px; height: 35rem" v-loading="meta.loading">
      <div v-if="isNew">
        <el-row type="flex" style="padding:0 20%;">
          <el-col>
            <el-input class="condition-wide left-pad" v-model="card.cardNo" placeholder="请输入住院号、证件号码" size="small" style="width: 20rem;"
              v-on:keyup.enter.native="query" clearable>
              <el-button @click="query" type="info" :loading="meta.loading" slot="append"
                icon="el-icon-search"></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <br />
      <!-- {{ patient }} -->
      <div v-if="patient && patient.patientCode">
        <div style="padding:10px 40px;">
          <el-descriptions title="患者信息" :column="6">
            <el-descriptions-item label="姓名">{{ patient.patientName }}</el-descriptions-item>
            <el-descriptions-item label="住院号">{{ patient.ipNo }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{ patient.patientGender | dictText('Gender') }}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{ patient.patientBirthday | age }}</el-descriptions-item>
            <el-descriptions-item label="医保类别">{{ patient.ipType }}</el-descriptions-item>
            <el-descriptions-item label="挂账时间">{{ patient.billingEndDate }}</el-descriptions-item>
          </el-descriptions>
          <el-divider></el-divider>
          <el-form class="left" ref="info" :rules="rules" :inline="true" :model="detailValue" label-width="9rem">

            <el-descriptions title="费用结算">
              <template slot="title">
                <div style="width: 30rem;display: flex;align-items:center">
                  <h4>费用结算</h4>
                  <div style="margin-left: 1rem;margin-right: 1rem;">
                    <el-button v-if="isRevoke" @click="cancelSettle" type="primary" size="small">取消结算</el-button>
                    <el-button v-else @click="run" type="primary" size="small" :disabled="!detailValue.ifExecutable">结算</el-button>
                  </div>
                  <div style="font-size: 1;">状态：{{ detailValue.state }}</div>
                </div>
                
                <!-- <template v-if="patient.state == '已离院' || patient.state == '已入住'">
                  <el-button v-if="settlementState == 0" type="primary" size="small" @click="run">开始结算</el-button>
                  <el-button v-if="settlementState == 1" type="primary" size="small">结束结算</el-button>
                </template> -->
              </template>
            </el-descriptions>
            <!-- {{ detailValue }} -->
            <el-row>
              <el-col :span="8">
                <el-form-item label="结算类别：" prop="settleCategory">
                  <el-select @change="detailValue.endDate = null" v-if="detailValue.ifNew" class="" v-model="detailValue.settleCategory" placeholder="请选择结算类别" size="small">                    
                    <el-option v-for="(item, index) in [{text:'阶段结算',code:'1'},{text:'出院结算',code:'2'}]" :key="index" :label="item.text" :value="item.code"></el-option>
                  </el-select>
                  <div v-else>{{ detailValue.settleCategory }}</div>

                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="结算起始时间：" prop="">
                  <div>{{ detailValue.startTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="detailValue.settleCategory != 2">
                <el-form-item label="结算结束时间：" prop="endDate">
                  <el-date-picker v-if="detailValue.ifNew" size="small" style="width:210px;" value-format="yyyy-MM-dd" v-model="detailValue.endDate" type="date" placeholder="请选择结束时间"></el-date-picker>
                  <div v-else>{{ detailValue.endTime }}</div>
                </el-form-item>
              </el-col>              
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="预交总额：" prop="">
                  <div>{{ detailValue.deposit || 0 }}元</div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="记账总额：" prop="">
                  <div>{{ detailValue.amount || 0 }}元</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="医保类别：" prop="">
                  <div>{{ detailValue.ipType }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="医保报销总额：" prop="">
                  <div>{{ detailValue.feeFund || 0 }}元</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="个人应付总额：" prop="">
                  <div>{{ detailValue.feeCash || 0 }}元</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="detailValue.ifArrears">
                <el-form-item label="需补交金额：" prop="">
                  <div>
                    <span>{{ detailValue.arrears || 0 }}</span>
                    <el-button type="primary" v-if="detailValue.arrears>0" style="margin-left:10px;" size="mini"
                      @click="meta.showPrepay = true">补交金额</el-button>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="detailValue.ifRefundable">
                <el-form-item label="结退金额：" prop="">
                  <div>
                    <span>{{ detailValue.refundable || 0 }}</span>
                    <el-button type="primary" style="margin-left:10px;" size="mini"
                      @click="meta.showRefund = true">退费</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-divider></el-divider>

          <el-descriptions title="费用明细" :colon="false">

          </el-descriptions>
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column type="expand" class="">
                  <template slot-scope="props">
                    <div class="pall10p nobd ">
                      <el-table :data="props.row.children" style="width: 100%;" :border="false">
                        <el-table-column prop="feeType" label="类别" align="center">
                          <template slot-scope="{row}">
                          <div>{{ $utils.Dict.text(row.feeType, "FeeType") }}</div>
                        </template>
                        </el-table-column>
                        <el-table-column prop="name" label="名称" align="center"></el-table-column>
                        <el-table-column prop="standard" label="规格" align="center"></el-table-column>
                        <el-table-column prop="price" label="单价" align="center"></el-table-column>
                        <el-table-column prop="advice.dosage" label="剂数" align="center"></el-table-column>
                        <el-table-column prop="total" label="数量" align="center"></el-table-column>
                        <el-table-column prop="amount" label="金额" align="center"></el-table-column>
                      </el-table>
                    </div>
                  </template>
                </el-table-column>
            <el-table-column label="处方编码" prop="rpNo"></el-table-column>
            <el-table-column label="处方类别" prop="rpClass"></el-table-column>
            <el-table-column label="科室" prop="deptCode">
              <template slot-scope="{row}">
                <div>{{ $utils.Dict.text(row.deptCode, "Dept") }}</div>
              </template>
            </el-table-column>            
            <el-table-column label="金额总计" prop="price">
              <template slot-scope="{row}">
                <div>{{ row.amount || 0 }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-else-if="isNoPatient"><h1>暂时没有查询到患者信息</h1></div>
      <refund v-if="meta.showRefund" :visible.sync="meta.showRefund"></refund>
      <prepay :patient="patient" :visible.sync="meta.showPrepay"></prepay>
    </el-main>
    <template #footer>
      <!-- {{ detailValue.ifExecFinish }} -->
      <el-button type="info" @click="cancel">关闭</el-button>
      <el-button :disabled="!detailValue.ifExecFinish" type="warning" @click="finsh">完成</el-button>
      <!-- <el-button v-if="settlementState == 1" type="primary" @click="save">打印发票</el-button> -->
      <br />
      <br />
      <el-checkbox v-model="checked">打印凭据</el-checkbox>
    </template>
  </hic-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {
    refund: () => import("./refund"),
    prepay: () => import('@/components/patient/disUse_newPrepay.vue'),
    // selectorStaff: () => import("@/components/_com/selectorStaff"),
  },
  props: {
    // infoDetail:Object,
    visible: Boolean,
    isNew: Boolean,
    from: String,
    ipNo: String,
    settleId: String,
    isRevoke:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      settlementState: 0,//0:未结算，1：结算中，2:结算完成
      checked: false,
      detailValue: {
        startTime: '',
        endTime: ''
      },
      rules: {
        endDate: [
          { required: true, message: "请选择结算结束时间", trigger: "change" },
        ]
      },
      tableData: [],
      patient: {},
      card: {
        cardNo: '' // ZY241122000074  su7 ZY240819000045
      },
      Settlement: {},
      meta: {
        loading: false,
        showRefund: false,
        showPrepay: false
      },
      timer: null,
      isNoPatient:null
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum", "user", "permission"]),
    nowTime() {
      return new Date(); //this.$utils.fmtDateTime(new Date())
    },
  },
  filters: {

  },
  watch: {
  },
  mounted() {
    // this.detailValue = this.infoDetail
  },
  methods: {
    open() {
      if (this.from == 'patient') {
        this.card.cardNo = this.ipNo
        this.query()
      }else if (this.from == 'settle' && !this.isNew) {//流水号查询详情
        this.queryDetail()
      }
    },
    cancel() {
      this.patient = null
      this.Settlement = null
      this.isNoPatient = null
      clearTimeout(this.timer)
      this.$emit("close");
      this.$emit("update:visible", false);
    },
    //流水号查询看结算详情
    async queryDetail(){
      this.meta.loading = true;

      let settleDetail = await api.Settlement.queryDetail(this.settleId)
      console.log('settleDetail==',settleDetail)
      let hospDetail = await api.Settlement.queryHosp(settleDetail.ipNo)
     
      console.log('hospDetail==',hospDetail)
      this.patient = hospDetail
      // console.log('patient==',this.patient)

      this.setDetailValue(settleDetail)
      this.isNoPatient = false
      this.meta.loading = false;    
    },
    //查询住院记录信息
    async query() {
      if (!this.card.cardNo) {
        return this.$message.error("请输入住院号、证件号码")
      }
      this.meta.loading = true;
      api.Settlement.queryHospitalization({ keyword: this.card.cardNo }).then((res) => {
        this.isNoPatient = false
        this.patient = res        
        this.currentSettlement()
      }).catch((err) => {
        this.isNoPatient = true
        // this.$message.error(err.message || err);
      }).finally(() => {
        this.meta.loading = false;
      })
    },
    //当前的结账信息
    currentSettlement() {
      // this.meta.loading = true;
      api.Settlement.current(this.patient.ipNo).then((res) => {
        this.setDetailValue(res)

        // this.$utils.Obj.propertyCopy(res,this.patient)
        // this.getFeesList(res.startBillingId,res.endBillingId)
      }).catch((err) => {
        this.$message.error(err.message || err);
      }).finally(() => {
        this.meta.loading = false;
      })
    },
    openTimer(){
      if(this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.currentSettlement()
      }, 3000)
    },
    //明细
    details() {
      this.meta.loading = true;
      api.Settlement.details(this.detailValue.id).then((res) => {
        console.log('明细===',res)
        this.tableData = res
      }).catch((err) => {
        this.$message.error(err.message || err);
      }).finally(() => {
        this.meta.loading = false;
      })
    },
    //执行结算
    run() {
      this.meta.loading = true;
      api.Settlement.run(this.Settlement).then(res => {
        this.setDetailValue(res)
      }).catch(error => {
        console.log(3)
        this.$message.error(error.message || error);
      }).finally(() => {
        this.meta.loading = false;
      })
    },
    //同步结果
    synchronous(){
      api.Settlement.result(this.detailValue.id).then(res => {
        this.setDetailValue(res)
      }).catch(error => {
        console.log(3)
        this.$message.error(error.message || error);
      }).finally(() => {
        this.meta.loading = false;
      })
    },

    setDetailValue(res) {
        this.detailValue = this.Settlement =  res
        if(!this.detailValue.startTime) this.detailValue.startTime = this.patient.startDate

        this.detailValue.amount = this.patient.amount
        this.detailValue.deposit = this.patient.deposit
        console.log('res.ifExecuting===',res)
        
        if(res.ifExecuting){
          this.openTimer()
          this.synchronous()
        } 
        else clearTimeout(this.timer)
        if(res.id) this.details()
    },
    //最后完成
    finsh() {
      this.meta.loading = true;
      api.Settlement.finsh(this.detailValue.id).then(res => {
        this.cancel()
      }).catch(error => {
        console.log(3)
        this.$message.error(error.message || error);
      }).finally(() => {
        this.meta.loading = false;
      })
    },
    //取消结算
    cancelSettle(){
      this.meta.loading = true;
      api.Settlement.cancel(this.Settlement).then(res => {
        // this.setDetailValue(res)
        this.openTimer()
        this.synchronous()
      }).catch(error => {
        console.log(3)
        this.$message.error(error.message || error);
      }).finally(() => {
        this.meta.loading = false;
      })
    }    
  },
  beforeRouteLeave(to, from, next) {
    return next();
  }
};
</script>

<style scoped>

.tx-c {
  text-align: center;
}

.pall10p {
  padding: 10px;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.ztitle {
  margin-top: 10px;
  color: #66b1ff;
}

.inputnw .el-input {
  width: 4rem !important;
}

.inputDelW {
  width: 12rem;
}

.el-form--inline .el-form-item {
  margin-right: 0px;
}
</style>
<style>
.nobd .el-table__cell {
  border-right: none !important;
}
</style>
